package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

@Serializable
data class ResetPasswordRequest(
    val identity: String,
    val code: Int,
    val newPassword: String
)